export default __webpack_public_path__ + "img/16ca85a604da2ab3af6b8ff49e1c4bc3.jpg";